import AutosuggestHighlightMatch from "autosuggest-highlight/match";
import AutosuggestHighlightParse from "autosuggest-highlight/parse";
import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import { Button } from "reactstrap";

import { printHelper } from "../../common/helpers";
// Props
//    type (1,2)   string
//    values (suggestions)  string[]
//    label (string displayed)  string
//    onChange (triggered when 'value' changes)
//    pushToTargetArray? (Types 2 pushes suggestions into the array)

// Types:
//      1: One field, once a suggestion is chosen, disables edition
//      2: One field, once a suggestion is chosen, pushes it's suggestion to
//      'target array' and proceeds to clear the 'value' field

class AutosuggestField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      suggestions: [],
      selectedItems: [],
      value: "",
      selected: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
    this.enableEdit = this.enableEdit.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
  }

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  getSuggestions(value) {
    const { values } = this.props;
    const escapedValue = this.escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp("^" + escapedValue, "i");
    const suggestions = values.filter((value) => {
      regex.test(value.name);
    });

    return values;
  }

  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  renderSuggestion(suggestion, { query }) {
    const { type } = this.props;
    let fullstring = " ";
    if (type == "1") {
      fullstring =
        suggestion.dni + " " + suggestion.name + " " + suggestion.lastname;
    } else if (type == "2") {
      fullstring = suggestion.name;
    } else {
      fullstring = "Undefined Type";
    }
    const matches = AutosuggestHighlightMatch(fullstring, query);
    const parts = AutosuggestHighlightParse(fullstring, matches);
    return (
      <span>
        {parts.map((part, index) => {
          const className = part.highlight
            ? "react-autosuggest__suggestion-match"
            : null;

          return (
            <span className={className} key={index}>
              {part.text}
            </span>
          );
        })}
      </span>
    );
  }

  async componentDidMount() {
    const { page } = this.state;
  }

  enableEdit() {
    const { selected } = this.state;
    this.setState({ selected: false });
  }

  async onChange(event, { newValue, method }) {
    const { selected } = this.state;
    if (!selected) {
      await this.props.onChange(newValue);
      await this.setState({
        value: newValue,
      });
    }
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  async onSuggestionSelected(
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) {
    const { type, onItemSelected } = this.props;

    // if (type == "1") {
    //   this.setState({
    //     selected: true
    //   });
    // } else if (type == "2") {
    //   onItemSelected(suggestion);
    //   await this.setState({ value: "" });
    await printHelper.printSell("Log");
    // }
  }

  shouldRenderSuggestions() {
    const { selected } = this.state;
    return !selected;
  }

  suggest(id) {
    const { value, selected, suggestions } = this.state;
    const inputProps = {
      placeholder: "",
      value,
      onChange: this.onChange,
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        id={id}
        // theme={{border: "2px solid lightgreen"}}
      />
    );
  }

  renderButtons() {
    const { type } = this.props;
    if (type == "1") {
      return (
        <div className="display-inline">
          <Button color="primary" className="display-inline suggest-buttons">
            Editar
          </Button>
          <Button color="primary" className="display-inline suggest-buttons">
            Nuevo
          </Button>
        </div>
      );
    }
  }

  render() {
    const { value } = this.state;
    const { label, suggestions, onChange } = this.props;
    return (
      <div className="w100">
        <div className="w100"> {label} </div>
        <div className="w100">
          {this.suggest("Client")}
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}

export default AutosuggestField;



// WEBPACK FOOTER //
// ./src/components/AutosuggestField/AutosuggestField.js